<div class="boletas-container">
  <!-- Título y subtítulo -->
  <app-page-header
    [title]="'Gestor de empleados'"
    [subtitle]="'Administra y genera las vacaciones de los empleados'"
  >
  </app-page-header>

  <br>

  <router-outlet></router-outlet>
</div>
